import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconLockSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.013 7.999a5 5 0 0 1 10 0V9h3v12h-16V9h3V7.999Zm8 0V9h-6V7.999a3 3 0 1 1 6 0Zm-1.717 6.155c0 .415-.202.784-.515 1.015l.183 2.04h-1.902l.207-2.023a1.261 1.261 0 0 1-.539-1.032c0-.7.575-1.267 1.283-1.267.709 0 1.283.567 1.283 1.267Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconLockSharpFill);
export default Memo;
